export default {
  schoolId: 1204,
  abbr: "cdtu",
};
